import { HistoryItemPeriod } from "../../interfaces/historyItem";

export class IntervalAndRepetition {


    constructor(interval: string, repetition: number, numerOfMinutes: number, periodInterval: HistoryItemPeriod)
    {
        this.Interval = interval;    
        this.Repetition = repetition;    
        this.NumerOfMinutes = numerOfMinutes;
        this.PeriodInterval = periodInterval;
    }

    Interval:string = "";
    Repetition:number = 1;
    NumerOfMinutes: number = 1;
    PeriodInterval: HistoryItemPeriod = HistoryItemPeriod.Min1;
    

}
